module.exports = __webpack_public_path__ + "static/media/day-icon.e70884f8.svg";